import { http, notify } from 'utils'
import { pick, set, findIndex, each, isObject } from 'lodash'

// Tag mutation imports.
import { SET_TAG, SET_TAGS, ADD_TAG, SET_TAGS_PAGINATION, SET_TAGS_PAGINATION_PROPERTY, RESET_TAGS, REMOVE_TAG, SET_TAG_PROPERTY, SET_TAG_TYPES } from 'vx/mutations'

const state = {
  tag: null,
  tags: [],
  pagination: {
    current_page: 1
  }
}

// Tag actions.
const actions = {
  getTags ({ commit }, params = { type: 'sport' }) {
    return http.get(`tags`, { params })
      .then((response) => {
        commit(SET_TAGS, response.data.data)
        commit(SET_TAGS_PAGINATION, response.data.meta)

        return response
      })
  },

  getTag ({ commit }, { id }) {
    return http.get(`tag/${id}`)
      .then((response) => {
        commit(SET_TAG, response.data)
        return response
      })
  },

  resetTag ({ commit }) {
    commit(SET_TAG, null)
  },

  /**
   * Update a tags associated tags.
   *
   * @return Promise
   */
  saveAssociatedTags ({ commit }, { id, payload }) {
    return http.put(`tag/${id}/associate_tags`, payload)
  },

  deleteTag ({ commit }, tag) {
    return http.delete(`tags/${tag.id}`)
      .then(() => {
        commit(REMOVE_TAG, tag)
      })
  },

  storeTag ({ commit }, payload) {
    return http.post('tags', payload)
      .then((response) => {
        commit(ADD_TAG, response.data)

        return response
      })
  },

  renameTag ({ commit }, { id, payload }) {
    return http.put(`tags/${id}/update`, payload)
      .then((response) => {
        commit(ADD_TAG, response.data)

        return response
      })
  },

  mergeTags ({ commit }, payload) {
    return http.post(`tags/merge`, payload)
      .then((response) => {
        commit(ADD_TAG, response.data)
        each(payload.tags, tag => commit(REMOVE_TAG, tag))

        return response
      })
  },

  mergeIntoTags ({ commit }, {id, payload}) {
    return http.post(`tags/${id}/merge_into`, payload)
      .then((response) => {
        commit(SET_TAG, response.data)
        each(payload.tags, (tag) => {
          if (tag.id !== id) {
            commit(REMOVE_TAG, tag)
          }
        })
        notify.success(`Successfully merged into ${response.data.name}`)
        return response
      }).catch((error) => {
        if (error.response.status === 400) {
          notify.error(error.response.data.message)
        } else {
          throw new Error(error)
        }
      })
  },

  resetTags ({ commit }) {
    commit(RESET_TAGS)
  },

  setTagsPaginationProperty ({ commit }, { property, value }) {
    commit(SET_TAGS_PAGINATION_PROPERTY, { property, value })
  },

  approveTags ({ commit }, tags) {
    return http.put('/vetting/tag/approve', { tags })
      .then((response) => {
        tags.ids.forEach(tag => {
          commit(REMOVE_TAG, { id: tag })
        })
        return response
      })
  }
}

// Tag state mutations.
const mutations = {
  [SET_TAGS] (state, tags) {
    state.tags = tags
  },

  [SET_TAG_TYPES] (state, tagTypes) {
    state.tagTypes = tagTypes
  },

  [SET_TAG] (state, tag) {
    state.tag = tag
  },

  [ADD_TAG] (state, tag) {
    let existingIndex = findIndex(state.tags, existing => existing.id === tag.id)

    if (existingIndex === -1) {
      state.tags.unshift(tag)
    } else {
      state.tags.splice(existingIndex, 1, tag)
    }
  },

  [SET_TAGS_PAGINATION] (state, pagination) {
    state.pagination = pick(pagination, ['current_page', 'per_page', 'total', 'last_page'])
  },

  [SET_TAGS_PAGINATION_PROPERTY] (state, { property, value }) {
    set(state.pagination, property, value)
  },

  [RESET_TAGS] (state) {
    state.tags = []
  },

  [REMOVE_TAG] (state, tag) {
    let existingIndex

    if (isObject(tag)) {
      existingIndex = findIndex(state.tags, existing => existing.id === tag.id)
    } else {
      existingIndex = findIndex(state.tags, existing => existing.id === tag)
    }

    if (existingIndex !== -1) {
      state.tags.splice(existingIndex, 1)
    }
  },

  [SET_TAG_PROPERTY] (state, { tagId, property, value }) {
    const index = state.tags.findIndex(element => element.id === tagId)
    if (index !== -1) {
      set(state.tags[index], property, value)
    }
  }
}

export default {
  namespaced: true, state, actions, mutations
}
